import TangoMessage from './tangoMessage'

export default {
  install: function (_Vue) {
    _Vue.prototype.$tango = new TangoMessage()
  }
}
